import axios from "axios";
import { Decrypt } from "../Crypt/AES";
import http from './index';
class UserApi {
  getAll() {
    return http.get("/user");
  }

  get(email: any) {
    //return http.get(`/tutorials/${id}`);
    console.log(email)
    return http.post("/user/Profile",email);

  }
  getPermission()
  {
    const token=Decrypt(localStorage.getItem('d2'))
    const header={
      "Content-type":"application/json",
      "Authorization":"Bearer "+token,
       
    }
    console.log(header)
    return http.get("UserPermission/Get",{headers:header})
  }
  login(data: any) {
    //console.log(data)
    return http.post("User/Login", data);
  }

  register(data: any) {
    return http.post("User/Register", data);
  }

  userupdate( data: any) {
    console.log(data)
    return http.put("user/update", data);
  }

  
}

export default new UserApi();
